import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760b545e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_ParamsSet = _resolveComponent("ParamsSet")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "设置广告位" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "广告标题",
            name: "title",
            rules: _ctx.rules.title
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.title,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            ref: "pid",
            label: "所属广告位",
            name: "pid",
            rules: [{ required: true, message: '请选择广告位' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.pid,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.pid) = $event)),
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _ctx.filterOption,
                onChange: _ctx.onPositionChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.position, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id,
                      label: item.name+'（'+ (item.terminal === 1 ? '移动端' : 'PC端') +'）'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name) + "（" + _toDisplayString(item.terminal === 1 ? "移动端" : "PC端") + "） ", 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option", "onChange"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "url",
            label: "跳转页面",
            name: "url",
            rules: [{ required: true, message: '请选择跳转链接' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.url,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.url) = $event)),
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _ctx.filterOption
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictionary, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id,
                      label: item.name+'（'+ (item.terminal === 1 ? '移动端' : 'PC端') +'）'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name) + "（" + _toDisplayString(item.terminal === 1 ? "移动端" : "PC端") + "） ", 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "filter-option"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "params",
            label: "跳转参数",
            name: "params",
            extra: "以键值对的形式"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.params,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.params) = $event)),
                placeholder: "请输入",
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamsSet, {
                    ref: "paramsRef",
                    params: _ctx.formState.params
                  }, null, 8, ["params"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "time",
            label: "生效时间",
            name: "time"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _ctx.formState.time,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.time) = $event)),
                "show-time": ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "target",
            label: "跳转方式",
            name: "target"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.target,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.target) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTarget, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "image",
            label: "广告图片",
            name: "image",
            rules: _ctx.rules.image,
            extra: _ctx.pictureExtra
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.image) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onImageChange,
                    "source-url": _ctx.formState.image
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "extra"]),
          _createVNode(_component_a_form_item, {
            ref: "image_background",
            label: "背景图片",
            name: "image_background",
            rules: _ctx.rules.image_background,
            extra: _ctx.pictureExtra
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image_background,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.image_background) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onBackgroundImageChange,
                    "source-url": _ctx.formState.image_background
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "extra"]),
          _createVNode(_component_a_form_item, {
            ref: "image_active",
            label: "点击状态图片",
            name: "image_active",
            rules: _ctx.rules.image_active,
            extra: _ctx.pictureExtra
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.image_active,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.image_active) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onActiveImageChange,
                    "source-url": _ctx.formState.image_active
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "extra"]),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}